import Enum from './enum'
import TermPattern from './term-pattern'

class Term extends Enum {
    static TERM_1 = 1; // 1学期
    static TERM_2 = 2; // 2学期
    static TERM_3 = 3; // 3学期
    static SEMESTER_1 = 11; // 前期
    static SEMESTER_2 = 12; // 後期
    static YEAR_ROUND = 99; // 年間 ・・・渡辺さんより学びの記録で「年度」ではなく「年間」としてほしい依頼

    static values() {
        return {
            [this.TERM_1]: '1学期',
            [this.TERM_2]: '2学期',
            [this.TERM_3]: '3学期',
            [this.SEMESTER_1]: '前期',
            [this.SEMESTER_2]: '後期',
            [this.YEAR_ROUND]: '年間'
        }
    }

    static valuesForTwo() {
        return {
            [this.SEMESTER_1]: '前期',
            [this.SEMESTER_2]: '後期',
        }
    }

    static valuesForThree() {
        return {
            [this.TERM_1]: '1学期',
            [this.TERM_2]: '2学期',
            [this.TERM_3]: '3学期',
        }
    }

    // 学期制のパターンを渡し、上記オブジェクト配列いずれかを返す
    static valuesFor(term_pattern) {
        if (term_pattern === TermPattern.TWO) {
            return this.valuesForTwo();
        }
        return this.valuesForThree();
    }

    // 学期制のパターンを渡し、SELECT用オプション配列を返す
    static optionsFor(term_pattern) {
        let object = null;
        if (term_pattern === TermPattern.TWO) {
            object = this.valuesForTwo();
        } else {
            object = this.valuesForThree();
        }
        let array = [];
        let keys = Object.keys(object);
        keys.forEach((key) => {
            array.push({
                key: key,
                label: object[key],
            });
        });

        return array;
    }
}

export default Term;
